import ChatInterface from './components/ChatInterface';
import './styles/styles.css'
function Chat(props) {
  return (
    // <div className="flex justify-center w-full">
      <ChatInterface {...props} />
    // </div>
  );
}

export default Chat;